module.exports = __webpack_public_path__ + "static/media/nytimes.com_2016_05_15_us_politics_donald-trump-women.html_plot.2b1316cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_2016_05_15_us_politics_donald-trump-women.html_plot.png
// module id = 406
// module chunks = 0